namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_notifications, {

		position: 'fixed',
		top: $mol_gap.block,
		right: $mol_gap.block,
		zIndex: 8,
		width: '22rem',
		maxWidth: '100%',
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.space,
		pointerEvents: 'none',

		Row: {
			background: {
				color: $mol_theme.back,
			},
			border: {
				radius: $mol_gap.round,
			},
			boxShadow: '0 0.5rem 1.5rem hsla(0,0%,0%,.25)',
			outline: 'solid 1px var(--mol_theme_line)',
			pointerEvents: 'auto',
			overflow: 'hidden',
		},

		Card: {
			width: '100%',
			background: {
				color: $mol_theme.card,
			},
			padding: {
				top: '0.5rem',
				right: '2.25rem',
				bottom: '0.5rem',
				left: '1rem',
			},
			gap: $mol_gap.space,
			position: 'relative',
			overflow: 'hidden',
			whiteSpace: 'normal',
			'::before': {
				content: '""',
				position: 'absolute',
				left: 0,
				top: 0,
				bottom: 0,
				width: '0.25rem',
				backgroundColor: `${ $shm_theme.success }`,
			},
			'[notification_type]': {
				success: {
					'::before': {
						backgroundColor: `${ $shm_theme.success }`,
					},
				},
				warning: {
					'::before': {
						backgroundColor: `${ $shm_theme.active }`,
					},
				},
				error: {
					'::before': {
						backgroundColor: `${ $shm_theme.error }`,
					},
				},
			},
		},

		Content: {
			flex: {
				direction: 'column',
				grow: 1,
				shrink: 1,
			},
			gap: '0.125rem',
			minWidth: 0,
			width: '100%',
			maxWidth: '100%',
		},

		Title: {
			display: 'block',
			font: {
				weight: 600,
			},
			flex: {
				shrink: 1,
			},
			minWidth: 0,
			maxWidth: '100%',
			whiteSpace: 'normal',
			wordBreak: 'break-word',
			overflowWrap: 'anywhere',
		},

		Message: {
			display: 'block',
			color: $mol_theme.text,
			flex: {
				shrink: 1,
			},
			minWidth: 0,
			maxWidth: '100%',
			whiteSpace: 'normal',
			wordBreak: 'break-word',
			overflowWrap: 'anywhere',
		},

		Details_row: {
			align: {
				items: 'center',
			},
			minWidth: 0,
			maxWidth: '100%',
		},

		Details: {
			overflow: 'hidden',
			maxHeight: '3rem',
			color: $mol_theme.shade,
			minWidth: 0,
			maxWidth: '100%',
			wordBreak: 'break-word',
			overflowWrap: 'anywhere',
			flex: {
				grow: 1,
				shrink: 1,
			},
		},

		Copy: {
			flex: {
				shrink: 0,
			},
			justify: {
				content: 'center',
			},
			align: {
				items: 'center',
			},
		},

		Copy_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},

		Close: {
			position: 'absolute',
			top: '0rem',
			right: '0rem',
			// padding: '0.25rem',
			width: '2rem',
			height: '2rem',
			justify: {
				content: 'center',
			},
			align: {
				items: 'center',
			},
		},

		Close_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},
		
	} )
	
}
